import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import Button from "src/shared/v-components/ui/Button.vue";
import DuplicateRewardSupplierComponentDrawer from "src/account-rewards/v-components/reward-suppliers-list/DuplicateRewardSupplierComponentDrawer.vue";
import { useComponentRewardSuppliers } from "src/shared/store/reward/supplier/composables";
import { computed, ref } from "vue";
import Strings from "js/Strings";
import RewardSupplierWorkflow from "src/account-rewards/workflow/RewardSupplierWorkflow";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateIntegrationSupplierButton',
    props: {
        eventBus: {},
        displayType: {}
    },
    setup(__props) {
        const props = __props;
        const isDrawerOpen = ref(false);
        const { componentRewardSuppliers } = useComponentRewardSuppliers();
        const selectedComponent = computed(() => {
            return componentRewardSuppliers.value.find((component) => Strings.capitalize(component === null || component === void 0 ? void 0 : component.display_name) ===
                Strings.capitalize(props.displayType));
        });
        const onDuplicate = () => {
            props.eventBus.trigger(RewardSupplierWorkflow.EVENTS.COMPLETE);
            isDrawerOpen.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(Button, {
                    level: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event) => (isDrawerOpen.value = true))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(" + New Reward ")
                    ]),
                    _: 1 /* STABLE */
                }),
                (selectedComponent.value)
                    ? (_openBlock(), _createBlock(DuplicateRewardSupplierComponentDrawer, {
                        key: 0,
                        modelValue: isDrawerOpen.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isDrawerOpen).value = $event)),
                        componentId: selectedComponent.value.id,
                        onClosed: _cache[2] || (_cache[2] = ($event) => (isDrawerOpen.value = false)),
                        onDuplicated: _cache[3] || (_cache[3] = ($event) => (onDuplicate()))
                    }, null, 8 /* PROPS */, ["modelValue", "componentId"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
